
function init() {
     $('.dropdown-table').click(function () {
          $(this).toggleClass('is-active');
          $(this).find('.dropdown-table-content').toggleClass('is-active');
     })
}



module.exports = {
     init,

}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/dropdownTable.js